import React from 'react';
import PropTypes from 'prop-types';

import CommonModal from 'components/elements/modals/CommonModal';

import './ResyncShopifyStoreModal.css';

const ResyncShopifyStoreModal = ({ open, onClose, onResync }) => (
  <CommonModal
    className="resync-shopify-modal__component"
    open={open}
    onClose={onClose}
  >
    <div className="wrapper">
      <div className="text-content">
        <strong>
          Are you sure you would like to re-Synchronize
          all your Shopify products?
        </strong>
      </div>
      <div className="buttons-block">
        <div
          className="modal-button"
          onClick={onResync}
          role="button"
          tabIndex={-1}
        >
          <div>
            <div>Yes, re-Sync</div>
            <div>all products</div>
          </div>
        </div>
        <div
          className="modal-button"
          onClick={onClose}
          role="button"
          tabIndex={-1}
        >
          <div>Not now</div>
        </div>
      </div>
    </div>
  </CommonModal>
);

ResyncShopifyStoreModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onResync: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

ResyncShopifyStoreModal.defaultProps = {
  open: null,
};

export default ResyncShopifyStoreModal;
